import SwipeableTemporaryDrawer from "../../common/miui-component/mui-sideDrawer.jsx";
import MUIButton from "../../common/miui-component/mui-button.jsx";
import SelectSearch from "react-select-search";
import {
  transactionStatus,
  paymentMethods,
  transactionType,
  paymentType,
} from "../../common/helper/status-constant.js";
import { FormField, SelectField } from "./formFields.js";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TuneIcon from "@mui/icons-material/Tune";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ConfigService from "../../../services/config-service.js";
import React, { useState, useEffect, useRef } from "react";
import {
  transactionSerachFormData,
  initialErrors,
  fieldValidation,
  initialFormData,
} from "../../common/helper/form-constants.js";
import { useSelector, useDispatch } from "react-redux";
import { useUserPermissionData } from "../../../services/perm-service.js";
import { current } from "@reduxjs/toolkit";

const SearchFilter = ({
  isOpenDrawer,
  setIsOpenDrawer,
  fetchTransaction,
  module,
  setAgentsData,
  setMerchantsData,
  setDistributorsData,
  formData,
  setFormData,
  isTransactionFilter=false
}) => {
  const [toggleFilter, setToggleFilter] = useState("agent");
  const userData = useSelector((state) => state.authReducer);
  const selectRef = useRef({});
  const isAdmin = userData?.user?.data?.role?.role_code === "ADMIN";
  const isDAdmin = userData?.user?.data?.role?.role_code === "DADMIN";
  const canFilterAgent = useUserPermissionData('filter_agent');
  const canFilterDistributor = useUserPermissionData('filter_distributor');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [advanceFilters, setAdvanceFilters] = useState([]);
  const [errors, setErrors] = useState({ ...initialErrors });
  // const [formData, setFormData] = useState({ ...transactionSerachFormData });
  const countFilledFieldsBySection = () => {
    return {
      agent: [
        "merchant_order_code",
        "order_code",
        "agent_email",
        "agent_mobile",
        "agent_code",
      ].filter((key) => formData[key] && formData[key].toString().trim() !== "")
        .length,

      merchant: [
        "customer_id",
        "distributor_id",
        "agent_id",
        "transaction_type",
        "status",
        "payment_method",
      ].filter((key) => formData[key] && formData[key].toString().trim() !== "")
        .length,

      advance: ["advanced_search_key", "advanced_search_value"].filter(
        (key) => formData[key] && formData[key].toString().trim() !== ""
      ).length,

      date: ["from_date", "to_date"].filter(
        (key) => formData[key] && formData[key].toString().trim() !== ""
      ).length,
    };
  };
  const filledFieldsCount = countFilledFieldsBySection();
  const handleIconClick = (name) => {
    if (selectRef.current) {
      if (selectRef.current[name]) {
        selectRef.current[name].focus(); // Focus on the specific dropdown input
      }
    }
  };

  const setSelectRef = (name, select) => {
    if (select) {
      if (selectRef.current) {
        selectRef.current[name] = select.querySelector("input");
      }
    }
  };
  const getCurrentDate = () => new Date().toISOString().split("T")[0];
  const handleChangeSearch = (e) => {
    const getAgentName = agents.filter((key) => key.value == e)?.[0]?.name;

    setFormData((prevData) => ({
      ...prevData,
      agent_id: e,
      //  agent_name: getAgentName,
    }));
  };
  const handleChangeSearchMerchant = (e) => {
    setFormData((prevData) => ({ ...prevData, ["customer_id"]: e }));
  };

  const handleChangeSearchDistributor = (e) => {
    setFormData((prevData) => ({ ...prevData, ["distributor_id"]: e }));
  };
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "filter_value") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value == "null" ? null : value,
        advanced_search_value: value == "null" ? null : value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value == "null" ? null : value,
      }));
    }
    validateField(name, value);
  };

  const getAgents = () => {
    ConfigService.getAgentsDropDown()
      .then((response) => {
        const agents = response.data.data;
        const arr = [{ name: "All Agents", value: "" }];
        for (var i = 0; i < agents.length; i++) {
          arr.push({
            name: agents[i].value,
            value: agents[i].key,
          });
        }
        setAgents(arr);
        setAgentsData && setAgentsData(arr)
      })
      .catch((error) => {});
  };

  const getDistributors = () => {
    ConfigService.getDistributorDropDown()
      .then((response) => {
        const agents = response.data.data;
        const arr = [{ name: "All Distributors", value: "" }];
        for (var i = 0; i < agents.length; i++) {
          arr.push({
            name: agents[i].value,
            value: agents[i].key,
          });
        }
        setDistributors(arr);
        setDistributorsData && setDistributorsData(arr)
      })
      .catch((error) => {});
  };

  const getMerchantsList = (e) => {
    ConfigService.getMerchantDropDown()
      .then((response) => {
        const merchts = response.data.data;
        const arr = [{ name: "All Merchants", value: "" }];
        for (var i = 0; i < merchts.length; i++) {
          arr.push({
            name: merchts[i].value,
            value: merchts[i].key,
          });
        }
        setMerchants(arr);
        setMerchantsData && setMerchantsData(arr)
      })
      .catch((error) => {});
  };
  const getAdvanceFilterValues = (e) => {
    ConfigService.getAdvanceFilterValues()
      .then((response) => {
        const arr = [];
        const filters = response.data.data;
        for (var i = 0; i < filters.length; i++) {
          arr.push({
            value: filters[i].code,
            label: filters[i].value,
          });
        }
        setAdvanceFilters(arr);
      })
      .catch((error) => {});
  };
  const handleFilter = (param) => {
    setToggleFilter(param);
  };
  useEffect(() => {
    if (module == "Statement") {
      setToggleFilter("merchant");
    }

    getDistributors();
    getAgents();
    getMerchantsList();
    getAdvanceFilterValues();
  }, []);

  const resetData = () => {
    setFormData({
      addressLine1: "",
      addressLine2: "",
      adminEmail: "",
      adminFullname: "",
      adminPassword: "",
      adminPhone: "",
      city: "",
      comm_grp_id: "",
      description: "",
      email: "",
      fullName: "",
      industry: "",
      limit_group: "",
      order_code: "",
      phoneNumber: "",
      postalCode: "",
      registrationNumber: "",
      state: "",
      transaction_type: "",
      merchant_order_code: "",
      agent_code: "",
      agent_email: "",
      agent_mobile: "",
      distributor_id: "",
      customer_id: "",
      agent_id: "",
      status: "",
      payment_method: "",
      advanced_search_key: "",
      filter_value: "",
      from_date: "",
      to_date: "",
     ...(isTransactionFilter && {utr_id:""})
    });
  };

  return (
    isOpenDrawer && (
      <SwipeableTemporaryDrawer {...{ isOpenDrawer, setIsOpenDrawer, module }}>
        <div className="container-fluid p-0 m-0 h-100 flex flex-col justify-between">
          <div className="row mt-3 flex-column-reverse flex-md-row">
            <div
              className="col-sm-12 col-md-7 mt-sm-4 mt-md-0 transaction-filter"
              style={{
                border: "1px solid rgb(180 172 172 / 68%)",
                padding: "15px",
                borderTopLeftRadius: "14px",
                borderBottomLeftRadius: "14px",
              }}
            >
              <div className="row" style={{ padding: "10px" }}>
                {toggleFilter === "agent" && (
                  <>
                   {isTransactionFilter &&  <FormFieldRow
                      id="utr_id"
                      label="UTR ID"
                      placeholder="UTR ID"
                      value={formData.utr_id}
                      onChange={handleChange}
                      error={errors.utr_id}
                    />}
                    <FormFieldRow
                      id="merchant_order_code"
                      label="Merchant Order Code"
                      placeholder="Merchant Order Code"
                      value={formData.merchant_order_code}
                      onChange={handleChange}
                      error={errors.merchant_order_code}
                    />
                    <FormFieldRow
                      id="order_code"
                      label="Order Code"
                      placeholder="Order Code"
                      value={formData.order_code}
                      onChange={handleChange}
                      error={errors.order_code}
                    />
                    {canFilterAgent && (
                      <>
                        <FormFieldRow
                          type="email"
                          id="agent_email"
                          label="Agent Email"
                          placeholder="Agent Email"
                          value={formData.agent_email}
                          onChange={handleChange}
                          error={errors.agent_email}
                        />
                        <FormFieldRow
                          id="agent_mobile"
                          label="Agent Mobile"
                          placeholder="Agent Mobile"
                          value={formData.agent_mobile}
                          onChange={handleChange}
                          error={errors.agent_mobile}
                        />
                        <FormFieldRow
                          id="agent_code"
                          label="Agent Code"
                          placeholder="Agent Code"
                          value={formData.agent_code}
                          onChange={handleChange}
                          error={errors.agent_code}
                        />
                      </>
                    )}
                  </>
                )}
                {toggleFilter === "merchant" && (
                  <>
                    {canFilterDistributor && (
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label>Select Distributor</label>
                        <SelectSearch
                          search={true}
                          options={distributors}
                          onChange={handleChangeSearchDistributor}
                          ref={(select) =>
                            setSelectRef("customer_id_2", select)
                          }
                          value={formData.distributor_id}
                          name="distributor_id"
                          placeholder="All Distributors"
                        />
                        <span
                          class="fa fa-angle-down errspan"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleIconClick("customer_id_2")}
                        ></span>
                      </div>
                    )}
                    {isAdmin && (
                      <div
                        className="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label>Select Merchant</label>
                        <SelectSearch
                          search={true}
                          options={merchants}
                          onChange={handleChangeSearchMerchant}
                          ref={(select) =>
                            setSelectRef("customer_id_1", select)
                          }
                          value={formData.customer_id}
                          name="customer_id"
                          placeholder="All Merchants"
                        />
                        <span
                          class="fa fa-angle-down errspan"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleIconClick("customer_id_1")}
                        ></span>
                      </div>
                    )}
                    {canFilterAgent && (
                      <>
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label>Select Agent</label>
                          <SelectSearch
                            value={formData.agent_id}
                            search={true}
                            options={agents}
                            onChange={handleChangeSearch}
                            ref={(select) =>
                              setSelectRef("customer_id_3", select)
                            }
                            name="agent_id"
                            placeholder="All Agents"
                          />
                          <span
                            class="fa fa-angle-down errspan"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleIconClick("customer_id_3")}
                          ></span>
                        </div>
                      </>
                    )}

                    {module != "Statement" && (
                      <>
                        <SelectFieldRow
                          id="searchTransaction"
                          label="Transaction Type"
                          name="transaction_type"
                          value={formData.transaction_type}
                          onChange={handleChange}
                          options={transactionType}
                          selectedField="All Transaction Type"
                        />
                        <SelectFieldRow
                          id="searchTransaction"
                          label="Status"
                          value={formData.status}
                          onChange={handleChange}
                          options={transactionStatus}
                          selectedField="All Status"
                          name="status"
                        />
                      </>
                    )}

                    {(() => {
                      if (module === "Statement") {
                        return (
                          <SelectFieldRow
                            id="searchTransaction"
                            label="Payment Type"
                            value={formData.payment_method}
                            onChange={handleChange}
                            options={paymentType}
                            selectedField="All Payment Types"
                            name="payment_method"
                          />
                        );
                      } else {
                        return (
                          <SelectFieldRow
                            id="searchTransaction"
                            label="Payment Method"
                            value={formData.payment_method}
                            onChange={handleChange}
                            options={paymentMethods}
                            selectedField="All Payment Methods"
                            name="payment_method"
                          />
                        );
                      }
                    })()}
                  </>
                )}
                {toggleFilter === "date" && (
                  <>
                    <FormFieldRow
                      type="date"
                      id="from_date"
                      label="From Date"
                      value={formData.from_date}
                      onChange={handleChange}
                      error={errors.from_date}
                      max={getCurrentDate()}
                    />
                    <FormFieldRow
                      type="date"
                      id="to_date"
                      label="To Date"
                      value={formData.to_date}
                      onChange={handleChange}
                      error={errors.to_date}
                      max={getCurrentDate()}
                    />
                  </>
                )}
                {toggleFilter === "advance" && (
                  <>
                    <SelectFieldRow
                      id="searchTransaction"
                      label="Advance Filter"
                      value={formData.advanced_search_key}
                      onChange={handleChange}
                      options={advanceFilters}
                      selectedField="Select Advance Filter"
                      name="advanced_search_key"
                    />
                    <FormFieldRow
                      id="filter_value"
                      label="Advance Filter Value"
                      placeholder="Advance Filter Value"
                      value={formData.advanced_search_value}
                      onChange={handleChange}
                      error={errors.advanced_search_value}
                      name="advanced_search_value"
                    />
                  </>
                )}
              </div>
            </div>
            <FilterTypeSidebar
              toggleFilter={toggleFilter}
              handleFilter={handleFilter}
              filledFieldsCount={filledFieldsCount}
              module={module}
            />
          </div>
          <FilterActions
            resetData={resetData}
            fetchTransaction={fetchTransaction}
            setIsOpenDrawer={setIsOpenDrawer}
            formData={formData}
            setFormData={setFormData}
            initialFormData={initialFormData}
          />
        </div>
      </SwipeableTemporaryDrawer>
    )
  );
};

const FormFieldRow = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  error,
  type = "text",
  maxlength,
}) => (
  <div className="col-12 mb-2">
    <div className="form-group frm" style={{ textAlign: "left" }}>
      <FormField
        type={type}
        id={id}
        name={id}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error}
        maxlength={maxlength}
      />
    </div>
  </div>
);

const SelectFieldRow = ({
  id,
  isRequierd,
  name,
  label,
  selectedField,
  value,
  onChange,
  error,
  options,
}) => (
  <div className="col-12 mb-2">
    <div className="form-group frm" style={{ textAlign: "left" }}>
      <SelectField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        options={options}
        selectedField={selectedField}
      />
    </div>
  </div>
);

const FilterTypeSidebar = ({
  toggleFilter,
  handleFilter,
  filledFieldsCount,
  module,
}) => (
  <div
    className="col-sm-12 col-md-5 mb-3 mb-md-0"
    style={{
      border: "1px solid rgb(180 172 172 / 68%)",
      padding: "15px",
      borderTopRightRadius: "14px",
      borderBottomRightRadius: "14px",
    }}
  >
    <div className="mb-3 filter-text" style={{ fontSize: "16px" }}>
      <span>Filter Type</span>
    </div>
    <div className="sidebar-parent-filter">
      <div className="flex flex-sm-row flex-md-column sidebar-filter">
        {[
          { type: "agent", label: "Basic search", icon: <SupportAgentIcon /> },
          {
            type: "merchant",
            label: "Select Filter",
            icon: <StorefrontIcon />,
          },
          { type: "advance", label: "Advance Filter", icon: <TuneIcon /> },
          { type: "date", label: "Date", icon: <DateRangeIcon /> },
        ]
          .filter(({ type }) => {
            return !(
              module === "Statement" &&
              (type === "agent" || type === "advance")
            );
          })
          .map(({ type, label, icon }) => (
            <div
              key={type}
              className="p-2 my-2 filter-text"
              onClick={() => handleFilter(type)}
              style={{
                fontWeight: "600",
                borderRadius: "10px",
                cursor: "pointer",
                background: toggleFilter === type ? "#eae1e1c2" : "",
              }}
            >
              {icon} {label} &nbsp;
              {filledFieldsCount[type] > 0 && (
                <span>({filledFieldsCount[type]})</span>
              )}
            </div>
          ))}
      </div>
    </div>
  </div>
);

const FilterActions = ({
  fetchTransaction,
  resetData,
  setIsOpenDrawer,
  formData,
  setFormData,
  initialFormData,
}) => {
  return (
    <div
      className="bottom-btn-filter d-flex gap-3 mt-6 justify-content-between "
      style={{ marginTop: "1.5rem" }}
    >
      <MUIButton
        btnOnClick={() => setIsOpenDrawer(false)}
        btnLabel="Cancel"
        btnStyle={{
          backgroundColor: "#495a69",
          color: "white",
          width: "80px",
          "&:hover": {
            backgroundColor: "rgb(117 121 124 / 82%)",
          },
        }}
      />
      <div className="d-flex justify-content-between gap-3">
        <MUIButton
          btnOnClick={() => resetData()}
          btnLabel="Reset"
          btnStyle={{
            backgroundColor: "white",
            color: "var(--primaryColor)",
            width: "80px",
            border: "1px solid #b1adadd9",
            "&:hover": {
              backgroundColor: "rgb(117 121 124 / 82%)",
            },
          }}
        />
        <MUIButton
          btnOnClick={() => fetchTransaction(formData)}
          btnLabel="Apply"
          btnStyle={{
            capitalize: "camelcase",
            backgroundColor: "white",
            border: "1px solid #b1adadd9",
            color: "var(--primaryColor)",
            "&:hover": {
              backgroundColor: "rgb(117 121 124 / 82%)",
            },
          }}
        />
      </div>
    </div>
  );
};

export default SearchFilter;
